<template>
    <b-modal
        id="paymentAuthenticationModal"
        ref="paymentAuthenticationModal"
        :lazy="false"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        :no-fade="true"
        hide-footer
        hide-header
    >
        <iframe
            ref="loadAuthIframe"
            width="100%"
            height="500vh"
            :src="url"
            frameborder="0"
            allowfullscreen
        ></iframe>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            url: ""
        };
    },
    mounted() {},
    destroy() {},
    watch: {},
    methods: {
        open(nextActionData) {
            let self = this;
            self.url = nextActionData.redirect_to_url.url;
            self.$refs.paymentAuthenticationModal.show();
            $(window).on("beforeunload", function () {
                return "Are you sure you want to leave?";
            });

            let event = function (ev) {
                if (ev.data) {
                    let result = "";
                    let isValidJSON = true;
                    try {
                        result = JSON.parse(ev.data);
                    } catch {
                        isValidJSON = false;
                    }

                    if (isValidJSON) {
                        if (result.message === "3DS-authentication-complete") {
                            // on3DSComplete();
                            console.log("3DS-authentication-complete");
                            window.removeEventListener("message", event, false);
                            $(window).off("beforeunload");
                            self.onComplete(result);
                        }
                    }
                }
            };

            window.addEventListener("message", event);
        },
        onComplete(data) {
            let self = this;
            self.$refs.paymentAuthenticationModal.hide();
            self.$emit("onComplete3ds", data);
        }
    }
};
</script>

<style lang="scss">
#paymentAuthenticationModal .modal-dialog .modal-content .modal-body {
    display: contents;
    padding: 0px;
}
</style>
